import * as Actions from '../../actions';

const initialState={
    data: [],
    selected: {
        data: null,
        isLoading: false,
        error: false,
    },
    isLoading: false,
    isLoaded: false,
    error: false
};

const getProductTypesReducer=(state=initialState,action) => {
    switch(action.type) {
        case Actions.GET_PRODUCT_TYPES: {
            return {
                ...state,
                isLoading: true,
                isLoaded: false,
                error: false
            };
        }
        case Actions.GET_PRODUCT_TYPES_SUCCESS: {
            return {
                ...state,
                data: action.payload,
                isLoading: false,
                isLoaded: true,
                error: false
            };
        }
        case Actions.GET_PRODUCT_TYPES_ERROR: {
            return {
                ...state,
                isLoading: false,
                isLoaded: false,
                error: action.error
            };
        }

        case Actions.GET_PRODUCT_TYPE: {
            return {
                ...state,
                isLoading: true,
                error: false
            };
        }
        case Actions.GET_PRODUCT_TYPE_SUCCESS: {
            return {
                ...state,
                selected: {
                    data: action.payload,
                    isLoading: false,
                    error: false
                },
                isLoading: false,
                error: false
            };
        }
        case Actions.GET_PRODUCT_TYPE_ERROR: {
            return {
                ...state,
                selected: {
                    data: null,
                    isLoading: false,
                    error: action.error
                },
                isLoading: false,
                error: action.error
            };
        }
        case Actions.ADD_PRODUCT_TYPE: {
            return {
                ...state,
                isLoading: true,
                isLoaded: false,
                error: false
            };
        }
        case Actions.ADD_PRODUCT_TYPE_SUCCESS: {
            return {
                ...state,
                data: [action.payload,...state.data],
                isLoading: false,
                isLoaded: true,
                error: false
            };
        }
        case Actions.ADD_PRODUCT_TYPE_ERROR: {
            return {
                ...state,
                isLoading: false,
                isLoaded: false,
                error: action.error
            };
        }
        case Actions.UPDATE_PRODUCT_TYPE: {
            return {
                ...state,
                isLoading: true,
                isLoaded: false,
                error: false
            };
        }
        case Actions.UPDATE_PRODUCT_TYPE_SUCCESS: {

            const index=state.data.findIndex(p => p._id===action.payload.productType._id)
            state.data[index]={...state.data[index],...action.payload.productType}
            return {
                ...state,
                isLoading: false,
                isLoaded: true,
                error: false
            };
        }
        case Actions.UPDATE_PRODUCT_TYPE_ERROR: {
            return {
                ...state,
                isLoading: false,
                isLoaded: false,
                error: action.error
            };
        }

        case Actions.REORDER_PRODUCT_TYPES: {
            return {
                ...state,
                isLoading: true,
                error: false
            };
        }
        case Actions.REORDER_PRODUCT_TYPES_SUCCESS: {
            const newData=action.payload.list.map(element => {
                let element2=state.data.find((pt) => {return pt._id===element._id})
                if(element2) {
                    element2.order=element.order
                    return element2
                }
                else
                    return element

            });
            return {
                ...state,
                data: newData,
                isLoading: false,
                error: false
            };
        }
        case Actions.REORDER_PRODUCT_TYPES_ERROR: {
            return {
                ...state,
                isLoading: false,
                error: action.error
            };
        }

        case Actions.DELETE_PRODUCT_TYPE: {
            return {
                ...state,
                isLoading: true,
                isLoaded: false,
                error: false
            };
        }
        case Actions.DELETE_PRODUCT_TYPE_SUCCESS: {
            return {
                ...state,
                data: state.data.filter(p => p._id!==action.payload),
                isLoading: false,
                isLoaded: true,
                error: false
            };
        }
        case Actions.DELETE_PRODUCT_TYPE_ERROR: {
            return {
                ...state,
                isLoading: false,
                isLoaded: false,
                error: action.error
            };
        }





        case Actions.ADD_PRODUCT: {
            return {
                ...state,
                isLoading: true,
                error: false
            };
        }
        case Actions.ADD_PRODUCT_SUCCESS: {
            const indexOfProductType=state.data.findIndex(pt => pt._id===action.payload.productType)
            state.data[indexOfProductType].products.push(action.payload.product)

            return {
                ...state,
                isLoading: false,
                error: false
            };
        }
        case Actions.ADD_PRODUCT_ERROR: {
            return {
                ...state,
                isLoading: false,
                error: action.error
            };
        }

        case Actions.DELETE_PRODUCT: {
            return {
                ...state,
                isLoading: true,
                error: false
            };
        }
        case Actions.DELETE_PRODUCT_SUCCESS: {
            const productTypeToUpdate=state.data.find(pt => pt._id===action.payload.productTypeID)

            productTypeToUpdate.products=productTypeToUpdate.products.filter(p => p._id!==action.payload._id)
            return {
                ...state,
                isLoading: false,
                error: false
            };
        }
        case Actions.DELETE_PRODUCT_ERROR: {
            return {
                ...state,
                isLoading: false,
                error: action.error
            };
        }

        case Actions.REORDER_PRODUCTS: {
            return {
                ...state,
                isLoading: true,
                error: false
            };
        }
        case Actions.REORDER_PRODUCTS_SUCCESS: {
            const productTypeIndex=state.data.findIndex(pt => pt._id===action.payload.productType)


            state.data[productTypeIndex]={
                ...state.data[productTypeIndex],products: action.payload.list.map(element => {
                    let element2=state.data[productTypeIndex].products.find((p) => p._id===element._id)
                    if(element2) {
                        element2.order=element.order
                        return element2
                    }
                    else
                        return element
                })
            }
            return {
                ...state,
                isLoading: false,
                error: false
            };
        }
        case Actions.REORDER_PRODUCTS_ERROR: {
            return {
                ...state,
                isLoading: false,
                error: action.error
            };
        }

        case Actions.TRANSFER_PRODUCT: {
            return {
                ...state,
                isLoading: true,
                error: false
            };
        }
        case Actions.TRANSFER_PRODUCT_SUCCESS: {
            const sourceProductTypeIndex=state.data.findIndex(pt => pt._id===action.payload.source)
            const destinationProductTypeIndex=state.data.findIndex(pt => pt._id===action.payload.destination)

            state.data[destinationProductTypeIndex]={
                ...state.data[destinationProductTypeIndex],products: action.payload.destinationList.map(element => {
                    let element2=state.data[destinationProductTypeIndex].products.find((p) => p._id===element._id)

                    if(!element2)
                        element2=state.data[sourceProductTypeIndex].products.find((p) => p._id===element._id)

                    element2.order=element.order
                    return element2
                })
            }

            state.data[sourceProductTypeIndex]={
                ...state.data[sourceProductTypeIndex],products: action.payload.sourceList.map(element => {
                    let element2=state.data[sourceProductTypeIndex].products.find((p) => p._id===element._id)

                    if(element2) {
                        element2.order=element.order
                        return element2
                    }
                })
            }


            return {
                ...state,
                isLoading: false,
                error: false
            };
        }
        case Actions.TRANSFER_PRODUCT_ERROR: {
            return {
                ...state,
                isLoading: false,
                error: action.error
            };
        }

        case Actions.UPDATE_PRODUCT: {
            return {
                ...state,
                isLoading: true,
                error: false
            };
        }
        case Actions.UPDATE_PRODUCT_SUCCESS: {

            const indexOfProductType=state.data.findIndex(pt => pt._id===action.payload.productType)
            const indexOfProduct=state.data[indexOfProductType].products.findIndex(p => p._id===action.payload._id)
            state.data[indexOfProductType].products[indexOfProduct]={...state.data[indexOfProductType].products[indexOfProduct],...action.payload}
            return {
                ...state,
                isLoading: false,
                error: false
            };
        }
        case Actions.UPDATE_PRODUCT_ERROR: {
            return {
                ...state,
                isLoading: false,
                error: action.error
            };
        }

        case Actions.UPDATE_PRODUCT_LISTS: {
            return {
                ...state,
                isLoading: true,
                error: false
            };
        }
        case Actions.UPDATE_PRODUCT_LISTS_SUCCESS: {
            state.data.forEach((pt,i) => {
                pt.products.forEach((p,j) => {
                    if(p._id===action.payload.product._id) {
                        state.data[i].products[j]= action.payload.product
                    }
                })
            })
            return {
                ...state,
                isLoading: false,
                error: false
            };
        }
        case Actions.UPDATE_PRODUCT_LISTS_ERROR: {
            return {
                ...state,
                isLoading: false,
                error: action.error
            };
        }

        case Actions.LOGOUT: {
            return {
                ...state,
                isLoading: true,
                error: false
            };
        }
        case Actions.LOGOUT_SUCCESS: {
            return {
                ...state,
                data: [],
                selected : {
                    data: null,
                    isLoading: false,
                    error: false,
                },
                isLoading: false,
                error: false
            }
        }
        case Actions.LOGOUT_ERROR: {
            return {
                ...state,
                isLoading: false,
                error: action.error
            }
        }


        default: {
            return state;
        }
    }
};

export default getProductTypesReducer